import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import AddUser from "../components/AddUser";
import { getListResult } from "../../../utils";
import { postCreateUser } from "../../../actions/AdminActions";
import { MyAccountModel } from "../../../models/MyAccount";

const mapStateToProps = ({
  masterRoleState, masterMfaPreferenceState, masterServiceProviderState, addUserState, healthPlanState, masterFeatureAccessState
}: ApplicationState) => ({
  masterRoleState: getListResult(masterRoleState.response),
  addUserState: addUserState.response,
  masterMfaPreferenceState: masterMfaPreferenceState.response,
  masterServiceProviderDefaultList: masterServiceProviderState.response,
  healthPlanState: getListResult(healthPlanState.response),
  masterFeatureAccessState: masterFeatureAccessState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    postCreateUser: (payload: MyAccountModel) => {
      dispatch(postCreateUser(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
